import { render, staticRenderFns } from "./VerifyBox.vue?vue&type=template&id=4002a29e"
import script from "./VerifyBox.vue?vue&type=script&lang=js"
export * from "./VerifyBox.vue?vue&type=script&lang=js"
import style0 from "./VerifyBox.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports